export interface IButtonBase {
    label: string | JSX.Element;
    ariaLabel?: string;
    handleClick?: (arg: any) => void;
    customClassName?: string;
}

export const ButtonBase = ({
    label,
    ariaLabel,
    handleClick,
    customClassName,
}: IButtonBase) => {
    return (
        <button
            className={`btn  ${customClassName}`}
            onClick={handleClick}
            type="button"
            aria-label={ariaLabel}
        >
            {label}
        </button>
    );
};
